/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ThankYouScreenBulkUpdatePathParams,
	ThankYouScreenBulkUpdateRequest,
	ThankYouScreenBulkUpdateResponse,
} from '../types/ThankYouScreenBulkUpdate'

/**
 * PATCH /campaigns/:campaign/thank-you-screens
 * @see backend/nexus/modules/Form/Http/Controllers/ThankYouScreenController.php ThankYouScreenController::bulkUpdate
 */
export async function thankYouScreenBulkUpdate(
	campaign: ThankYouScreenBulkUpdatePathParams['campaign'],
	data: ThankYouScreenBulkUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ThankYouScreenBulkUpdateResponse>> {
	return axiosInstance.patch(`/campaigns/${campaign}/thank-you-screens`, data, config)
}
